<template>
  <div class="mt120">
    <techStep 
      v-for="(step, i) in stepsTech" :key="i"
      :number="i"
      :title="$t('pageTech.stepsTech['+i+'].title')"
      :subtitle="$t('pageTech.stepsTech['+i+'].subtitle')"  
      :description="$t('pageTech.stepsTech['+i+'].description')"
      :list="$t('pageTech.stepsTech['+i+'].list')"
      :img="$t('pageTech.stepsTech['+i+'].img')"
    />
    <techExpertises />
    <div class="technologiesBg">
      <techTechnologies />
    </div>
    <Footer />
    <FooterSmall />
    <scrollBack />
  </div>
</template>

<script>
import json from '@/locales/en.json'
import techExpertises from '@/components/tech/techExpertises.vue'
import techStep from "@/components/tech/techStep.vue"
import techTechnologies from '@/components/tech/techTechnologies.vue'
import Footer from "@/components/Footer.vue"
import FooterSmall from "@/components/FooterSmall.vue"
import scrollBack from "@/components/scrollBack.vue"

export default {
  name: "tech",
  components: {
    techStep,
    techExpertises,
    techTechnologies,
    Footer,
    FooterSmall,
    scrollBack
  },
  data: function() {
    return {
      stepsTech: json.pageTech.stepsTech
    }
  }
};
</script> 

<style lang="scss" scoped>
.technologiesBg{
  background-color: $light;
  padding:60px 0 20px 0;
}
</style>
